// The roles an `adminusers/{eventId}` map may hold. Mirrors EVENT_ROLES in
// functions/lib/userAdmin.js, which is the authority (setEventRole refuses
// anything else) — change both. See the rules' isEventAdmin / isEventEditor /
// isEventStaff for what each one opens.
export const EVENT_ROLES = ['eventadmin', 'moderator', 'basic', 'weddingadmin']
